// extracted by mini-css-extract-plugin
export var wrapper = "ButtonPager-module--wrapper--Ta2Rl";
export var link = "ButtonPager-module--link--OOTMN";
export var img = "ButtonPager-module--img--FSLWh";
export var arrow = "ButtonPager-module--arrow--4V9jy";